import { SimpleMaskInputField } from 'components/InputsMex/SimpleInputs';
import { emailRegex, inputNumericoEnteros } from 'components/InputsMex/validaciones';
import InformacionAgente from 'components/MisDatosForm/InformacionAgente';
import React from 'react'
import { Button } from 'react-bootstrap';
import { regex } from 'utils/validaciones';
import { SimpleWrapper, TextInput } from '../Componentes/entradas';

const defaultDisclaimer = [{}, {}, {}];

export const DatosAsegurado = ({
    clavesAgente = [],
    catalogo: {
        mensajes = defaultDisclaimer,
        comisionAnualBruta = {},
        longitudNumeroPromotoria = {},
        primaIntermediaAnual = {}
    }
}) => {


    const format = (number) => {
        return new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(number);
    };

    const validarLimites = (value, campo, decimal = true) => {

        if ((value * 1 <= campo?.max?.value && value * 1 >= campo?.min?.value) ||
            (campo?.max?.value === null && campo?.min?.value === null) || value === null) {
            return true
        }
        if (decimal) {
            return `Ingrese un valor entre ${format(campo?.min?.value * 1)} y ${format(campo?.max?.value * 1)}`
        } else {
            return `Ingrese un valor entre ${campo?.min?.value * 1} y ${campo?.max?.value * 1}`

        }
    }


    return (
        <div>
            <div className="d-flex justify-content-center">
                <div className="col-lg-8 col-12">
                    <div className="row w-100">
                        <div className="col-12 col-md-6  py-4">
                            <div className="container-accidentes">
                                <h3 className="font-mex text-center" style={{ fontSize: "30px" }}>
                                    Datos para la cotización
                                </h3>
                            </div>
                            <div className="form-group">
                                <SimpleWrapper info={mensajes.find(msg => msg.tipo === "IngresoAnualBruto")?.texto} label="Ingreso anual bruto (Comisiones)*" name="datosCotizacion.ingresoAnualBruto">
                                    <TextInput
                                        inputProps={{
                                            name: 'datosCotizacion.ingresoAnualBruto',
                                            type: 'number',
                                            onKeyDown: inputNumericoEnteros,

                                        }}
                                        prefijo='$ '
                                        numerico={true}
                                        rules={{
                                            required: comisionAnualBruta?.required,
                                             validate: {
                                                 limites: (value) => (value<=2147483647)?true:'Valor fuera de los límites',
                                            },
                                        }}
                                        extrasClasses="hide-arrows"
                                    />
                                </SimpleWrapper>
                            </div>
                            <div className="form-group">
                                <SimpleWrapper info={mensajes.find(msg => msg.tipo === "PrimaIntermediaAnual")?.texto} label="Prima intermediada anual (Tamaño de la cartera)" name="datosCotizacion.primaIntAnual">
                                    <TextInput
                                        inputProps={{
                                            name: 'datosCotizacion.primaIntAnual',
                                            type: 'number',
                                            onKeyDown: inputNumericoEnteros,
                                        }}
                                        rules={
                                            {
                                                validate: {
                                                    limites: (value) => validarLimites(value, primaIntermediaAnual),
                                                },
                                            }
                                        }
                                        prefijo='$ '
                                        numerico={true}
                                        extrasClasses="hide-arrows"
                                    />
                                </SimpleWrapper>
                            </div>
                            <div className="form-group">
                                <SimpleWrapper label="Número promotoría" name="datosCotizacion.numeroPromotoria">
                                    <TextInput
                                        inputProps={{
                                            name: "datosCotizacion.numeroPromotoria",
                                            type: "number",
                                            onKeyDown: inputNumericoEnteros,
                                        }}
                                        rules={{
                                            maxLength: {
                                                value: 4,
                                                message: "Ingrese hasta 4 dígitos",
                                            },
                                            validate: {
                                                limites: (value) => validarLimites(value, longitudNumeroPromotoria, false)
                                            }
                                        }}
                                        thousandSeparator={false}
                                        decimalScale={0}
                                        numerico={true}
                                    />
                                </SimpleWrapper>
                            </div>
                            <div className="container-accidentes">
                                <div
                                    className="disclaimer-form-datos"
                                    style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                    dangerouslySetInnerHTML={{
                                        __html: mensajes?.find(msg => msg.tipo === 'Validacion')?.texto,
                                    }
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6  py-4">
                            <div className="container-accidentes">
                                <h3 className="font-mex text-center" style={{ fontSize: "30px" }}>
                                    Datos personales
                                </h3>
                            </div>

                            <div className="form-group">
                                <SimpleWrapper label="Nombre*" name="datosCliente.usuNombre">
                                    <TextInput
                                        inputProps={{
                                            name: "datosCliente.usuNombre",
                                            type: "string",
                                        }}
                                        rules={{
                                            required: regex.requiredMessage,
                                            pattern: {
                                                value: regex.nombre.value,
                                                message: regex.nombre.mensaje,
                                            },
                                        }}
                                    />
                                </SimpleWrapper>
                            </div>
                            <div className="form-group">
                                <SimpleWrapper label="RFC*" name="datosCliente.usuRfc">
                                    <TextInput
                                        inputProps={{
                                            name: "datosCliente.usuRfc",
                                            // type: "number",
                                        }}
                                        extrasClasses="hide-arrows"
                                        rules={{
                                            required: 'Este campo es obligatorio',
                                            pattern: {
                                                value: /^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/,
                                                message: "RFC incorrecto, el formato esperado es: AAAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos"
                                            },
                                            maxLength: {
                                                value: 13,
                                                message: "Ingrese hasta 13 caracteres",
                                            },
                                        }}
                                    />
                                </SimpleWrapper>
                            </div>

                            <React.Fragment>
                                <div className="form-group container-accidentes">
                                    <SimpleMaskInputField
                                        name="datosCliente.usuTelefono"
                                        label="Teléfono (opcional)"
                                        type="mask"
                                        placeholder="999-9999-999"
                                        mask="999-9999-999"
                                        isNumberInt={true}
                                        inputProps={{
                                            name: "datosCliente.usuTelefono",
                                            type: "number",
                                            onKeyDown: inputNumericoEnteros,
                                        }}
                                        classContainer="hide-arrows"
                                        rules={{
                                            pattern: {
                                                value: regex.telefono10.value,
                                                message: regex.telefono10.mensaje,
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Debe ingresar mínimo 10 números",
                                            },
                                            maxLength: {
                                                value: 20,
                                                message: "Solo puede ingresar máximo 20 números",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="form-group container-accidentes">
                                    <p
                                        className="text-enviar-cotizacion"
                                        style={{ fontSize: "20px", fontFamily: "Futura-Medium" }}
                                    >
                                        Compártenos tu correo para enviarte tu cotización
                                    </p>
                                </div>
                            </React.Fragment>


                            <div className="form-group">
                                <SimpleWrapper label="Correo (opcional)" name="datosCliente.usuCorreo">
                                    <TextInput
                                        inputProps={{
                                            name: "datosCliente.usuCorreo",
                                        }}
                                        rules={{
                                            // required: regex.requiredMessage,
                                            validate: {
                                                email: (value) => {
                                                    if (value === "") {
                                                        return true;
                                                    }
                                                    const valid = emailRegex.test(value);
                                                    if (!valid) {
                                                        return "Ingrese un correo válido";
                                                    }
                                                    return true;
                                                },
                                            },
                                        }}
                                    />
                                </SimpleWrapper>
                            </div>


                            <div className="container-accidentes">
                                <div
                                    className="disclaimer-form-datos"
                                    style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                    dangerouslySetInnerHTML={{
                                        __html: mensajes?.find(msg => msg.tipo === 'Informativo')?.texto,
                                    }}
                                />
                            </div>
                            <div className="container-accidentes">
                                <div
                                    className="disclaimer-form-datos"
                                    style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                    dangerouslySetInnerHTML={{
                                        __html: mensajes?.find(msg => msg.tipo === 'Autorizacion')?.texto,
                                    }}
                                />
                            </div>
                            <InformacionAgente
                                className="mt-3"
                                border={false}
                                options={clavesAgente}
                            />
                            <div className="d-flex justify-content-center mt-5">
                                <Button type="submit" className="w-75">
                                    CONTINUAR
                                </Button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
